import api, { addAuthToData, addAuthToParams } from './api';

export const ordersService = {
  // Create order
  createOrder: async (orderData) => {
    try {
      const dataWithAuth = addAuthToData(orderData);
      const response = await api.post('/orders.php?action=create', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Get all orders
  getOrders: async () => {
    try {
      const response = await api.get('/orders.php?action=read');
      return response.data;
    } catch (error) {
      console.error('API Error in getOrders:', error);
      if (error.response) {
        throw new Error(error.response.data?.message || `Server error: ${error.response.status}`);
      } else if (error.request) {
        throw new Error('Network error - no response from server');
      } else {
        throw new Error(error.message || 'Unknown error');
      }
    }
  },

  // Get single order
  getOrder: async (id) => {
    try {
      const response = await api.get(`/orders.php?action=read&id=${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Update order
  updateOrder: async (orderData) => {
    try {
      const dataWithAuth = addAuthToData(orderData);
      const response = await api.post('/orders.php?action=update', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Delete order
  deleteOrder: async (id) => {
    try {
      const url = addAuthToParams(`/orders.php?action=delete&id=${id}`);
      const response = await api.post(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  }
};